import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AppPermissionService } from '@core/services/app-permission.service';
import { environment } from '@env/environment';
// import Echo from 'laravel-echo';
import { DepositDataService } from '../services/deposit-data.service';
import { MerchantBankHttpService } from '@core/services/merchant-bank-http.service';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { GroupHttpService } from '@core/services/group-http.service';
import { SocketIoService } from '@core/services/socket.io-service';

@Component({
  selector: 'deposit-wrapper',
  templateUrl: './deposit-wrapper.component.html',
  styleUrls: ['./deposit-wrapper.component.scss'],
})
export class DepositWrapperComponent implements OnInit, OnDestroy {

  totalCrypto = 0;
  totalBankingNew = 0;

  // echo: Echo;

  merchantBankAccounts$: ReplaySubject<any[]> = new ReplaySubject(1);
  merchantBankAccountsCrypto$: Observable<any[]>;

  groups: any;

  // permissions
  canViewBankingTab: boolean;
  canViewCryptoTab: boolean;

  newDepositPageAccessWhitelist = ['support11'];
  canAccessNewDepositPage = false;
  username = JSON.parse(localStorage.getItem('user_data')).username;

  private subscriptions: Subscription[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private appPermissionService: AppPermissionService,
    private depositDataService: DepositDataService,
    private merchantBankHttpService: MerchantBankHttpService,
    private groupHttpService: GroupHttpService,
    private socketIoService: SocketIoService
  ) {
    // const SocketIoClient = require('socket.io-client');
    // const socketHost: string = environment.socketHost;
    // const user_token = JSON.parse(localStorage.getItem('user_token'));
    // try {
    //   this.echo = new Echo({
    //     broadcaster: 'socket.io',
    //     client: SocketIoClient,
    //     host: socketHost,
    //     auth: {
    //       headers: {
    //           'access-token': user_token.access_token,
    //           'token-selector': user_token.plaintext_token,
    //           'X-User-Model': 'bo'
    //       }
    //     }
    //   });
    // } catch (e) {
    //   console.log(e);
    // }
    this.subscriptions.push(
      this.socketIoService.getSocketData().subscribe(socketData => {
        const
          channelName: string = socketData.channelName,
          eventName: string = socketData.eventName,
          listener = (res) => {
            this.totalCrypto = res.crypto;
            this.cdr.detectChanges();
          },
          listenerNew = (res) => {
            this.totalBankingNew = res.banking;
            this.cdr.detectChanges();
          };

        if (socketData.type == 'private') {
          if (channelName == 'deposit-count-new-channel' && eventName == 'DepositCountEventNew') {
            listenerNew(socketData.data)
          }
          else if (channelName == 'deposit-count-channel' && eventName == 'DepositCountEvent') {
            listener(socketData.data);
          }
        }
      })
    );
  }

  ngOnInit() {
    // Access to new deposit page
    // if (this.newDepositPageAccessWhitelist.includes(this.username)) {
    //   this.canAccessNewDepositPage = true;
    // }

    // Permissions
    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canViewBankingTab = appPermissions.view_banking_deposits;
      this.canViewCryptoTab = appPermissions.view_crypto_deposits;

      this.cdr.detectChanges();
    });
    this.subscriptions.push(apSub);

    // // Deposit count event listener
    // const listener = (res) => {
    //   this.totalBanking = res.banking;
    //   this.totalCrypto = res.crypto;
    //   this.cdr.detectChanges();
    // };

    // const listenerNew = (res) => {
    //   this.totalBankingNew = res.banking;
    //   this.cdr.detectChanges();
    // };

    // this.echo.channel('deposit-count-new-channel').listen('.DepositCountEventNew', listenerNew);

    // this.echo.channel('deposit-count-channel').listen('.DepositCountEvent', listener);

    this.socketIoService.getPrivateSocket().then(privateSocket => {
      privateSocket
        .joinChannel(`deposit-count-new-channel`)
        .listenEvent('DepositCountEventNew');
    });
    this.socketIoService.getPrivateSocket().then(privateSocket => {
      privateSocket
        .joinChannel(`deposit-count-channel`)
        .listenEvent('DepositCountEvent');
    });

    const data = {
      newDepositVersion: false
    }

    const data2 = {
      newDepositVersion: true
    }

    this.depositDataService.triggerDepositCount(data).subscribe();
    this.depositDataService.triggerDepositCount(data2).subscribe();

    // Get member groups
    this.getMemberGroups();

    // Get merchant bank list
    this.getMerchantBankAccountList();
  }

  ngOnDestroy(): void {
    this.subscriptions.map(sb => sb.unsubscribe());
    this.socketIoService.leavePrivate('deposit-count-new-channel', 'DepositCountEventNew');
    this.socketIoService.leavePrivate('deposit-count-channel', 'DepositCountEvent');
    // this.echo.disconnect();
  }

  getMerchantBankAccountList() {

    this.merchantBankHttpService.getMerchantBanksAccount().subscribe(res => {
      res.forEach(elm => {
        elm.name = elm.account_number
          ? `${elm.bank_code} - ${elm.account_name} - ${elm.account_number}`
          : `${elm.bank_code} - ${elm.account_name}`;
      });

      // Emit the API response to the shared ReplaySubject
      this.merchantBankAccounts$.next(res);
    });

    // Transform data for crypto accounts
    this.merchantBankAccountsCrypto$ = this.merchantBankAccounts$.pipe(
      map(res => {
        const cryptoAccounts = res.filter(v => v.is_crypto === 1);
        cryptoAccounts.unshift({
          id: 'all',
          name: 'All'
        });
        return cryptoAccounts;
      })
    );
  }

  getMemberGroups() {
    this.groupHttpService.getGroups().subscribe(res => {
      this.groups = res;
    });
  }
}